import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'SmartCal360AssignCustomerFilterPipe'
})
export class SmartCal360AssignCustomerFilterPipe implements PipeTransform{
    transform(smartCalAssignCustomerList, filterCustomerName) {
        if(smartCalAssignCustomerList.length===0 || filterCustomerName===''){
            return smartCalAssignCustomerList;
        }
        else{
            return smartCalAssignCustomerList.filter(a=>{
                return a.BillToName.toLowerCase()===filterCustomerName.toLowerCase();
            })
        }
        
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/smartcal360/pipes/smartcal360AssignCustomerPipe.ts